import { render } from "./TransfertInscriptionView.vue?vue&type=template&id=01754555"
import script from "./TransfertInscriptionView.vue?vue&type=script&lang=js"
export * from "./TransfertInscriptionView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__